// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"ContinueLink_visuallyHidden__WosuO","stars":"ContinueLink_stars__ggoS3","link":"ContinueLink_link__WSynK","spinner":"ContinueLink_spinner__UIgGY"};